import axios from 'axios';

/**
 * Global contact-center reports (PR #1311, merged into feat/aht-metric).
 * Every endpoint returns the same envelope `{ columns: string[], data: object[] }`
 * and accepts an optional `keys` map to rename/select columns from the client.
 *
 * Routes:
 *  - POST /reports/contact-center/calls                  (global, optional time grouping via `groupBy`)
 *  - POST /reports/contact-center/calls/segments         (one row per segment)
 *  - POST /reports/contact-center/appointments           (global, optional time grouping)
 *  - POST /reports/contact-center/appointments/services  (one row per service)
 *  - POST /reports/contact-center/agents                 (one row per agent)
 */

const toISO = value => new Date(value).toISOString();

const cleanArray = value => (Array.isArray(value) && value.length > 0 ? value : undefined);

const base = (start, end, keys) => ({
  start: toISO(start),
  end: toISO(end),
  keys,
});

const state = {};

const mutations = {};

const actions = {
  calls(context, {
    start, end, groupBy, timezone, keys,
  } = {}) {
    return axios.post('reports/contact-center/calls', {
      ...base(start, end, keys),
      groupBy,
      timezone,
    }).then(({ data }) => data);
  },

  callsBySegment(context, {
    start, end, segments, keys,
  } = {}) {
    return axios.post('reports/contact-center/calls/segments', {
      ...base(start, end, keys),
      segments: cleanArray(segments),
    }).then(({ data }) => data);
  },

  appointments(context, {
    start, end, groupBy, timezone, keys,
  } = {}) {
    return axios.post('reports/contact-center/appointments', {
      ...base(start, end, keys),
      groupBy,
      timezone,
    }).then(({ data }) => data);
  },

  appointmentsByService(context, {
    start, end, services, keys,
  } = {}) {
    return axios.post('reports/contact-center/appointments/services', {
      ...base(start, end, keys),
      services: cleanArray(services),
    }).then(({ data }) => data);
  },

  agents(context, { start, end, keys } = {}) {
    return axios.post('reports/contact-center/agents', base(start, end, keys))
      .then(({ data }) => data);
  },
};

const getters = {};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
